angular.module('bribac.actions.auth', [])

  .constant('authActions', {
      AUTHORIZE: function(data) {
        return {
          type: 'AUTH.AUTHORIZE',
          payload: {data: data}
        }
      },

      DEAUTHORIZE: function() {
        return {
          type: 'AUTH.DEAUTHORIZE',
          payload: null
        }
      }
    }
  )
